import { combineReducers } from "redux";
import auth from "./auth";
import base from "./base";
import basket from "./basket";
import menuOrder from "./menuOrder/menuOrderSlice";

const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    auth,
    base,
    basket,
    menuOrder,
    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
